import { CSSProperties } from 'react';

export const DEFAULT_HERO_BACKGROUND =
  'https://images.ctfassets.net/u8ph4bd6pxag/5vyRJJ886SB8iJdwjsrTjY/7c2d6481a63ff9cca08330fdec51984b/Life___Family_partners_image.jpg';

/** Safe inline background-image for CMS-provided URLs (avoids CSS injection in styled rules). */
export const heroBackgroundImageStyle = (url: string): CSSProperties => ({
  backgroundImage: `url(${JSON.stringify(url)})`,
});
